import { render, staticRenderFns } from "./Structures.vue?vue&type=template&id=64d35975"
import script from "./Structures.vue?vue&type=script&lang=ts"
export * from "./Structures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports